import React from 'react'
import type { BusyButtonProps } from './index'
import { BusyButton } from './index'

// No default bsStyle: a `text-*` utility sets color with `!important`, which beats
// `.btn-link`'s theme-aware `--bs-link-color` and would freeze the button at one
// colour in both light and dark mode. Only emit a colour class when a caller asks
// for a semantic one (e.g. bsStyle="danger").
export const BusyButtonLink = ({ className, style, bsStyle, ...props }: BusyButtonProps) => {
  const computedClassName = ['fw-bold', 'text-decoration-none', 'p-0', 'm-0', bsStyle && `text-${bsStyle}`, className]
    .filter(Boolean)
    .join(' ')

  return (
    <BusyButton
      {...props}
      variant="link"
      bsStyle="link"
      className={computedClassName}
      style={style ?? { lineHeight: 0.4 }}
    />
  )
}
